// extracted by mini-css-extract-plugin
export default {"skeletonCard":"FeaturedProducts_skeletonCard__J87+o","shimmer":"FeaturedProducts_shimmer__c3iiv"};